export default function () {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="116" height="27" viewBox="0 0 116 27" fill="none">
            <path d="M76.27 16.5158H78.9055L82.3876 3.51465H79.7546L76.27 16.5158Z" fill="white" />
            <path
                d="M54.0297 10.7383H50.593L52.3442 13.8072H46.2618C46.1358 13.8145 46.0146 13.7575 45.9399 13.6558C45.8651 13.554 45.8469 13.4214 45.8914 13.3033L47.6551 6.72713C47.7399 6.44137 47.995 6.23967 48.2926 6.22322H56.6073C56.7329 6.21684 56.8533 6.27419 56.9274 6.37577C57.0016 6.47734 57.0195 6.60945 56.9751 6.72713L55.9547 10.5368L57.7386 13.6611C57.7562 13.6056 57.7764 13.5502 57.7915 13.4948L59.656 6.53816C60.1045 4.86767 59.1118 3.51465 57.4438 3.51465H48.9175C47.2495 3.51465 45.5337 4.86767 45.0852 6.53816L43.2207 13.4948C42.7747 15.1627 43.7649 16.5183 45.4329 16.5183H57.338L54.0297 10.7383Z"
                fill="white"
            />
            <path
                d="M71.7554 13.8981H62.6093L65.3808 3.5249H62.6722L59.8654 14.0064C59.4925 15.3998 60.3189 16.526 61.7097 16.526H73.7509L77.2355 3.5249H74.527L71.7554 13.8981Z"
                fill="white"
            />
            <path d="M115.941 3.51465H101.35L100.625 6.21818H106.604L103.845 16.5158H106.48L109.239 6.21818H115.218L115.941 3.51465Z" fill="white" />
            <path d="M81.4175 16.5161H95.9783L96.7013 13.8176H84.7761L85.4312 11.366H97.359L98.0821 8.66504H83.5214L81.4175 16.5161Z" fill="white" />
            <path d="M84.1792 6.21566H98.74L99.4631 3.51465H84.9024L84.1792 6.21566Z" fill="white" />
            <path d="M33.873 11.3783H41.1471L41.8703 8.6748H34.5987L33.873 11.3783Z" fill="white" />
            <path d="M18.5889 0H11.2544L17.6617 8.66741L22.3381 5.07951L18.5889 0Z" fill="white" />
            <path d="M26.065 20.0334H33.3995L27.5213 12.0815L22.4619 15.158L26.065 20.0334Z" fill="white" />
            <path d="M40.1166 0H30.9024L14.971 12.2226H18.4581L0.848633 27L31.0158 8.67749H27.4884L40.1166 0Z" fill="url(#paint0_linear_540_1483)" />
            <defs>
                <linearGradient id="paint0_linear_540_1483" x1="37.9447" y1="-1.72387e-07" x2="0.894626" y2="26.9558" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#EAC64C" />
                    <stop offset="0.554786" stopColor="#C09325" />
                    <stop offset="1" stopColor="#AF7D14" />
                </linearGradient>
            </defs>
        </svg>
    );
}
